/* src/app/components/menu-popover/menu-popover.component.scss */
.wrapper {
  background: var(--ion-color-primary);
  color: white;
  padding: 12px;
  font-weight: bold;
}
.separator {
  width: 100%;
  height: 1px;
  margin: 16px 0;
  background: white;
}
ion-icon {
  width: 32px;
  margin-right: 13px;
  padding: 4px;
  border-radius: 0;
}
.version {
  opacity: 0.3;
  font-size: x-small;
}
ion-row {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}
.name {
  margin-top: 12px;
  font-size: large;
}
a {
  text-decoration: none;
  color: white;
}
ion-button {
  color: white;
  --background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
}
.lang-row {
  margin-left: 10px;
}
.lang-row ion-col {
  padding: 0px;
}
.icon-lang {
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.6;
}
.icon-lang ion-icon {
  margin: 0px !important;
  padding: 0px !important;
  zoom: 1.6;
}
.selected {
  opacity: 1 !important;
}
.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}
/*# sourceMappingURL=menu-popover.component.css.map */
